export const ASSETS_URL = 'https://storage.googleapis.com/bq-static/static/';
export const COLOR_VARIANTS = {
    BQ_GREEN: 'bq-green',
    BQ_BURGUNDY: 'bq-burgundy',
    BQ_BLUE: 'bq-blue',
    BQ_TURQUOISE: 'bq-turquoise',
    BQ_RED: 'bq-red',
    BQ_ORANGE: 'bq-orange',
}
export const COLOR_VARIANT_ORDER = ['bq-green', 'bq-burgundy', 'bq-blue', 'bq-turquoise', 'bq-red', 'bq-green']

export const QUERY_PARAM_IFRAME = 'iframe'